module.exports = __webpack_public_path__ + "static/media/d2.f6ecb3d7.jpg";